<div class="all-content">
  <div class="top">
    {{ getLanguages('code_data/title') }}
  </div>
  <div class="row">
    <div class="div-search">
      <div class="search">
        <input type="text" [(ngModel)]="searchText" (keyup.enter)="searchProfiles()">
      </div>
      <button (click)="searchProfiles()">
        {{ getLanguages('search') }}
      </button>
    </div>
  </div>
  <div class="row justify-content-space-between">
    <div class="item item-3">
      <span style="width: 30vh;"> {{ getLanguages('code_data/select_type') }} </span>
      <button class="button-menu" [matMenuTriggerFor]="typeCodeData" style="width: 30vh;">
        <span>
          {{ selectedTypeCodeData.label ? getName(selectedTypeCodeData.label) : getLanguages('select') }}
        </span>
        <i class="fa-solid fa-caret-down"></i>
      </button>
      <mat-menu #typeCodeData="matMenu">
        <div class="menu">
          <div class="input" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="searchTypeCodeData" placeholder="{{ getLanguages('search') }}">
            <i class="fa-solid fa-magnifying-glass"></i>
          </div>
          <div class="scroll">
            <ng-container *ngFor="let item of codeDataArray">
              <ng-container *ngIf="getName(item.label)?.toLowerCase().includes(searchTypeCodeData?.toLowerCase())">
                <div class="item-menu" (click)="choseItemSelect(item)">
                  <span [ngClass]="item?.slug == selectedTypeCodeData?.slug ? 'valid-span' : 'invalid-span'">
                    {{ getName(item.label) }}
                  </span>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </mat-menu>
    </div>

    <div class="div-button">
      <button class="save" (click)="newRow()" *ngIf="getSystemPermission('code_data', 'create_code_data') && selectedTypeCodeData?.slug">{{ getLanguages('addRow') }}</button>
      <button class="save" (click)="save()" *ngIf="getSystemPermission('code_data', 'create_code_data') && selectedTypeCodeData?.slug"> {{ getLanguages('save') }}</button>
    </div>
  </div>

  <div class="row" style="padding: 1vh 1.5vh;">
    <p-table *ngIf="getDisplayedRows().length !== 0 && !isLoading" [value]="getDisplayedRows()" class="table-project">
      <ng-template pTemplate="header">
        <tr>
          <th [ngStyle]="{'width': selectedTypeCodeData?.slug == 'corporations-extended-attribute' ? '60%' : '85%'}">
            <span> {{ getLanguages('businessSolution/modal/extendedAttributes/name') }} </span>         
          </th>
          <th [ngStyle]="{'width': '20%'}" *ngIf="selectedTypeCodeData?.slug == 'corporations-extended-attribute'">
            <span> {{ getLanguages('code_data/attibute_type') }} </span>         
          </th>
          <th [ngStyle]="{'width': '20%'}" *ngIf="selectedTypeCodeData?.slug == 'corporations-extended-attribute'">
            <span> {{ getLanguages('code_data/values') }} </span>         
          </th>
          <th class="td-15">
            <span> {{ getLanguages('attachment/action') }} </span>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr>
          <td [ngStyle]="{'width': selectedTypeCodeData?.slug == 'corporations-extended-attribute' ? '60%' : '85%'}">
            <textarea [(ngModel)]="row.name"></textarea>
          </td>
          <td [ngStyle]="{'width': '20%'}" *ngIf="selectedTypeCodeData?.slug == 'corporations-extended-attribute'">
            <button 
              class="button-menu-table" 
              [matMenuTriggerFor]="type">
              <span>
                {{ getExtendedAttribute(row?.type) ? getName(getExtendedAttribute(row?.type).name) : getLanguages('select') }}
              </span>
              <i class="fa-solid fa-caret-down"></i>
            </button>    
            <mat-menu #type="matMenu">
              <div class="menu">
                <div class="input" (click)="$event.stopPropagation()">
                  <input type="text" [(ngModel)]="searchContent" placeholder="{{ getLanguages('search') }}">
                  <i class="fa-solid fa-magnifying-glass"></i>
                </div>
                <div class="scroll">
                  <ng-container *ngFor="let item of extendedAttributeArray">
                    <ng-container *ngIf="getName(item.name)?.toLowerCase().includes(searchContent?.toLowerCase())">
                      <div class="item-menu" (click)="choseItemSelectTypeExtendedAttribute(item, row)">
                        <span [ngClass]="item?.slug == row?.type ? 'valid-span' : 'invalid-span'">
                          {{ getName(item.name) }}
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </mat-menu>
          </td>
          <td [ngStyle]="{'width': '20%'}" *ngIf="selectedTypeCodeData?.slug == 'corporations-extended-attribute'" [ngClass]="row?.type !== 'restricted-text' ? 'cell-disabled' : ''">
            <textarea 
              *ngIf="row?.type == 'restricted-text'" 
              [(ngModel)]="row.values"
              placeholder="Item1; Item2; Item3">
            </textarea>
          </td>
          <td class="td-15">
            <div class="align-center">
              <i class="fas fa-trash pointer" (click)="deleteRow(row.uuid)"></i>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="div-paginator" *ngIf="getDisplayedRows().length !== 0 && !isLoading">
    <div class="paginator">
      <span>
        {{ getLanguages('businessSolution/modal/strategy/itensPage') }}
      </span>
      <button [matMenuTriggerFor]="menu" class="itens-per-page">
        {{ getItemsPerPage() }}
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="choseItemsPage(10)">10</button>
        <button mat-menu-item (click)="choseItemsPage(20)">20</button>
        <button mat-menu-item (click)="choseItemsPage(30)">30</button>
      </mat-menu>
      <span>
        {{ getLanguages('businessSolution/modal/strategy/totalPages') }}
      </span>
      <span class="totalPages">
        {{ getTotalPages()}}
      </span>
      <button [ngClass]="getCurrentPages() === 1 ? 'disabled-arrow' : 'arrow'" [disabled]="getCurrentPages() === 1"
        (click)="onPageChange(getCurrentPages() - 1)">
        <i class="fa-solid fa-angle-left"></i>
      </button>
      <input type="number" [ngModel]="getCurrentPages()" disabled (blur)="checkValue($event)">
      <button [ngClass]="getCurrentPages() == getTotalPages() ? 'disabled-arrow' : 'arrow'"
        [disabled]="getCurrentPages() == getTotalPages()" (click)="onPageChange(getCurrentPages() + 1)">
        <i class="fa-solid fa-angle-right"></i>
      </button>
    </div>
  </div>
</div>